import React, { FC } from 'react';

const RemovalOfResidues: FC = () => {
  return (
    <div>
      <p>
        Для видалення залишків необхідно прислати параметр
        &quot;deleteOther&quot;: true і всі залишки у аптеці, що присутні в
        базі, але не прийшли у цьомі запиті будуть видалені.
      </p>
      <p>
        З своєї сторони ми видаляємо всі залишки, що не оновлювались більше
        доби.
      </p>
    </div>
  );
};

export default RemovalOfResidues;
